import * as yup from 'yup'

export default yup.object().shape({
  billing_person_id: yup.string().required('Informe o Responsável Financeiro'),
  discount_rate: yup
    .number()
    .typeError('Digite um número válido.')
    .min(0, 'A Taxa de Desconto deve ser 0 ou maior.'),
  uau_vendedor_code: yup.string().nullable().optional(),
  uau_modelo_comissao_code: yup.string().nullable().optional()
})
